import { ActionType } from "../actions/actionTypes";

type CustomerState = {
  viewedCustomers?: Customer[];
  createdCustomers?: Customer[];
  customer?: Customer;
  customerPolicies?: PolicyListItems[];
  customerTasks?: Task[];
  customerQuotes?: ApplicationListItems[];
  customerTransactions?: ApplicationListItems[];
  customerClaims?: any[];
  customerBilling?: BillingAccounts[];
  error?: any;
  loading: boolean;
};

const INITIAL_STATE = {
  loading: false
};

export default (
  state: CustomerState = INITIAL_STATE,
  action: ActionType
): CustomerState => {
  switch (action.type) {
    case "CUSTOMER_REQUEST": {
      return { ...state, error: null, loading: true };
    }
    case "FETCH_CUSTOMERS_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "FETCH_CUSTOMER_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "FETCH_CUSTOMER_POLICIES_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "FETCH_CUSTOMER_TASKS_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "FETCH_CUSTOMER_QUOTES_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "FETCH_CUSTOMER_TRANSACTIONS_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "FETCH_CUSTOMER_BILLING_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "FETCH_CUSTOMER_FAILURE": {
      return { ...state, ...action.payload, loading: false };
    }
    default:
      return state;
  }
};
